module.exports = __webpack_public_path__ + "img/1550418358.7aae6fa7.jpg";